import { Injectable } from "@angular/core";
import {
  ApplicationInsights,
  IExceptionTelemetry,
  DistributedTracingModes
} from "@microsoft/applicationinsights-web";
import { Router, ActivatedRouteSnapshot, ResolveEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { INSTRUMENT_KEY } from "../config";

@Injectable()
export class ApplicationInsightsService {
  private appInsights: ApplicationInsights;

  constructor(private router: Router) {
    if (INSTRUMENT_KEY) {
      this.appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: INSTRUMENT_KEY,
          distributedTracingMode: DistributedTracingModes.W3C,
          enableCorsCorrelation: true
        }
      });

      this.appInsights.loadAppInsights();
      this.loadCustomTelemetryProperties();
      this.createRouterSubscription();
    }
  }

  setUserId(userId: string) {
    if (this.appInsights) {
      this.appInsights.setAuthenticatedUserContext(userId);
    }
  }

  clearUserId() {
    if (this.appInsights) {
      this.appInsights.clearAuthenticatedUserContext();
    }
  }

  logPageView(name?: string, uri?: string) {
    if (this.appInsights) {
      this.appInsights.trackPageView({ name, uri });
    }
  }

  logException(error: Error) {
    if (this.appInsights) {
      let exception: IExceptionTelemetry = {
        exception: error
      };
      this.appInsights.trackException(exception);
    }
  }

  private loadCustomTelemetryProperties() {
    this.appInsights.addTelemetryInitializer(envelope => {
      envelope.tags["ai.cloud.role"] = "insite-admin";
    });
  }

  private createRouterSubscription() {
    this.router.events
      .pipe(filter(event => event instanceof ResolveEnd))
      .subscribe((event: ResolveEnd) => {
        const activatedComponent = this.getActivatedComponent(event.state.root);
        if (activatedComponent) {
          this.logPageView(
            `${activatedComponent.name} ${this.getRouteTemplate(
              event.state.root
            )}`,
            event.urlAfterRedirects
          );
        } else {
          this.logPageView(null, event.urlAfterRedirects);
        }
      });
  }

  private getActivatedComponent(snapshot: ActivatedRouteSnapshot): any {
    if (snapshot.firstChild) {
      return this.getActivatedComponent(snapshot.firstChild);
    }

    return snapshot.component;
  }

  private getRouteTemplate(snapshot: ActivatedRouteSnapshot): string {
    let path = "";
    if (snapshot.routeConfig) {
      path += snapshot.routeConfig.path;
    }

    if (snapshot.firstChild) {
      return path + this.getRouteTemplate(snapshot.firstChild);
    }

    return path;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/logger/appinsights.service.ts